import * as Sentry from '@sentry/browser';

const { SENTRY_DSN, SENTRY_RELEASE, OFCS_ENVIRONMENT, OFCS_PROJECT } = window.env ?? {};

if (SENTRY_DSN) {
    Sentry.init({
        dsn: SENTRY_DSN,
        environment: OFCS_ENVIRONMENT ?? 'development',
        normalizeDepth: 3,
        maxBreadcrumbs: 50,
        release: SENTRY_RELEASE,
    });

    Sentry.setTags({
        instance: OFCS_PROJECT,
    });
}

export default Sentry;
